import { render, staticRenderFns } from "./honorcategory.vue?vue&type=template&id=5225567c&"
import script from "./honorcategory.vue?vue&type=script&lang=js&"
export * from "./honorcategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports